import { render, staticRenderFns } from "./HeaderBasket.vue?vue&type=template&id=32664c22&"
import script from "./HeaderBasket.vue?vue&type=script&lang=js&"
export * from "./HeaderBasket.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBasket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports